export default class Food {
    constructor() {
        this.scroller = $('.food .btn--to-menu')
        this.isPhone = false
        this.daySelectButton = $('.bottom-button')
        this.food = $('.food')
    }

    /**
     * Close everything
     */
    closeAll() {
        $('.type__container').removeClass('is-open')
    }

    /**
     * Scroll down to menu type
     */
    scrollToGrid() {
        $('html, body').animate({ scrollTop: $('.food__type').offset().top - 130 }, 500)
    }

    /**
     * Check for mobile devices (640px >)
     */
    checkPhone() {
        let w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0)
        let state = this.isPhone

        this.isPhone = w <= 640
    }

    /**
     * Select day menu
     */
    selectDayMenu(e) {
        e.preventDefault()
        let me = $(e.currentTarget)

        if (!me.hasClass('btn--inactive')) {
            me.closest('.food__menu__day').toggleClass('is-selected')
        }
    }

    /**
     * trigger login modal
     */
    triggerLogin() {
        $('.header__link--user').trigger('click')
        $('#l_login_email').focus()
    }

    /**
     * Initialize class
     */
    init() {
        if (this.food.length) {
            $(window).on('resize', () => this.checkPhone())

            $('body').on('click', '.food-login', () => this.triggerLogin())
        }

        if (this.scroller.length) {
            this.scroller.on('click', () => this.scrollToGrid())
            this.checkPhone()
        }

        if (this.daySelectButton.length) {
            this.daySelectButton.on('click', e => this.selectDayMenu(e))
        }
    }
}
